import * as React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

const TESTID = 'icon-minus';
export const MinusIcon = ({ fill = 'gcBlue', size = 'xsmall' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 12 2"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.666016 1.00016C0.666016 0.631963 0.964496 0.333496 1.33268 0.333496H10.666C11.0342 0.333496 11.3327 0.631963 11.3327 1.00016C11.3327 1.36836 11.0342 1.66683 10.666 1.66683H1.33268C0.964496 1.66683 0.666016 1.36836 0.666016 1.00016Z"
                className={fillStyles}
            />
        </svg>
    );
};
MinusIcon.TEST_ID = TESTID;
